import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/lancamentos/')({
  component: () => <Navigate to="/lancamentos/pagamentos" replace />,
});
